
if (window.location.pathname === '/blogs' || window.location.pathname === '/blogs/') {
  window.location.href = '/blogs/journal';
}


// updatecart
// --- Global Cart Update Function ---
window.updateGlobalCart = function (isState) {
  $.getJSON('/cart.js', function (cart) {
    const $drawer = $('#cartDrawer');
    const $itemsContainer = $('#cartDrawerItems');
    const $emptyState = $('#cartDrawerEmpty');
    const $footer = $('#cartDrawerFooter');

    // Currency formatter helper preserving money class and explicit decimals for app conversion
    const formatCurrency = (cents) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      return `<span class="money">$${amount}</span>`;
    };

    // 1. Update all cart count badges and total price
    $('#cartDrawerBadge, .cart-dot, #cartTriggerBadge').text(cart.item_count);
    $('#cartTotalPrice').html(formatCurrency(cart.total_price));

    // 2. Handle Empty State vs Filled State
    if (cart.items.length === 0) {
      $('#openCartBtn').find('.cart-dot').hide();
      $itemsContainer.empty().hide();
      $emptyState.addClass('is-visible');
      $footer.hide();
      return;
    } else {
      $('#openCartBtn').find('.cart-dot').show();
      $emptyState.removeClass('is-visible');
      $footer.show();
      $itemsContainer.css('display', 'flex');
    }

    // 3. Flicker-free DOM update for cart items
    const $existingItems = $itemsContainer.find('.cart-drawer__item');

    // If the number of items changed (added a new product or removed one completely), re-render list
    if ($existingItems.length !== cart.items.length) {
      let itemsHtml = '';
      cart.items.forEach((item) => {
        const variantTitle = item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : '';
        const imageUrl = item.image ? item.image : '';

        itemsHtml += `
                    <div class="cart-drawer__item" data-cart-item-key="${item.key}" data-unit-price-cents="${item.price}">
                        <div class="cart-drawer__item-img">
                            <img height="auto" width="auto" src="${imageUrl}" alt="${item.product_title}">
                        </div>
                        <div class="cart-drawer__item-info">
                            <h4 class="cart-drawer__item-title">${item.product_title}</h4>
                            ${variantTitle}
                            <p class="cart-drawer__item-price" data-item-unit-price>${formatCurrency(item.price)}</p>
                            <div class="cart-drawer__item-actions">
                                <div class="cart-drawer__quantity">
                                    <button type="button" class="qty-btn qty-minus" aria-label="Decrease quantity">−</button>
                                    <span class="qty-val">${item.quantity}</span>
                                    <button type="button" class="qty-btn qty-plus" aria-label="Increase quantity">+</button>
                                </div>
                                <button type="button" class="cart-drawer__remove" aria-label="Remove item">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="cart-drawer__item-total">${formatCurrency(item.line_price)}</div>
                    </div>
                `;
      });
      $itemsContainer.html(itemsHtml);
    } else {
      // Just update text values silently if item count is the same (prevents DOM re-loading/flickering)
      cart.items.forEach((item, index) => {
        const $itemRow = $existingItems.eq(index);
        $itemRow.attr('data-cart-item-key', item.key);
        if (isState) {
          $itemRow.find('.qty-val').text(item.quantity);
        }
        $itemRow.find('[data-item-unit-price]').html(formatCurrency(item.price));
        $itemRow.find('.cart-drawer__item-total').html(formatCurrency(item.line_price));
      });
    }

    // Trigger currency converter re-selection for new cart drawer elements
    if (typeof window.reselectActiveCurrency === 'function') {
      window.reselectActiveCurrency();
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(window.reselectActiveCurrency);
      }
      setTimeout(window.reselectActiveCurrency, 50);
      setTimeout(window.reselectActiveCurrency, 150);
    }
  });
};

//==================
// Currency selector
//==================

$(document).ready(() => {
  const $toggleBtn = $('.currency-menu-toggle');
  const $wrapper = $('.currency-selector-wrapper');

  if ($toggleBtn.length) {
    $toggleBtn.on('click', (e) => {
      e.stopPropagation();
      const isExpanded = $toggleBtn.attr('aria-expanded') === 'true';
      $toggleBtn.attr('aria-expanded', !isExpanded);
      $wrapper.toggleClass('active');
    });

    $(document).on('click', () => {
      $toggleBtn.attr('aria-expanded', 'false');
      $wrapper.removeClass('active');
    });
  }
});




//mute videos
$(document).ready(function () {
  $("video").each(function () {
    const $video = $(this);

    // 1. Create a wrapper dynamically to isolate layout without changing existing classes
    const $wrapper = $("<div>", {
      css: {
        position: "relative",
        display: "block",
        width: "100%",
        height: "100%"
      }
    });



    // Wrap the video element
    $video.wrap($wrapper);

    // 2. Create the click target overlay button
    const $btn = $("<div>", {
      class: "auto-mute-btn"
    });

    // 3. Correct way to check if a video is playing (paused is false and current time > 0)
    const isPlaying = $video[0].currentTime > 0 && !$video[0].paused && !$video[0].ended;

    if (isPlaying) {
      $btn.show();
    } else {
      $btn.hide();
    }

    // Optional: Update visibility dynamically if playback state changes
    $video.on("play", function () {
      $btn.show();
    });

    $video.on("pause", function () {
      $btn.hide();
    });

    // Append the button right after the video inside the wrapper
    $video.after($btn);

    // 3. Sync state function mapping video property to data attribute for ::before / ::after display swapping
    const syncState = function () {
      if ($video.prop("muted")) {
        $btn.attr("data-state", "muted");
      } else {
        $btn.attr("data-state", "unmuted");
      }
    };

    // Run initial sync
    syncState();

    // 4. Handle click event to toggle audio and update states cleanly
    $btn.on("click", function (e) {
      e.stopPropagation();
      const isMuted = $video.prop("muted");
      $video.prop("muted", !isMuted);
      syncState();
    });

    // Handle external audio updates
    $video.on("volumechange", syncState);
  });
});

